import type { SettingsAppStorage } from '../../../domain/settings';
import { isAppSettingsKey } from '../../../domain/settings';
import type { UserSettings } from '../../../domain/user';
import { isUserSettingsKey } from '../../../domain/user';
import { mutateUserSettings } from '../../../features/user/useUserSettingsMutation';
import { appStore, AppMode } from '../../appStore';
import { defaultUserSettings } from '../setDefaultUserSettings';
import { removeSettingsItems, setSettingsItems } from '../windowMessaging';

type SettingsCommands = {
  setSettingsStorageValue(keyValue: SettingsAppStorage): void;
};

const applyMissingDefaults = (commands: SettingsCommands, settingsStorage: SettingsAppStorage) => {
  const { mode } = appStore.getState();

  if (mode !== AppMode.Extension) {
    return;
  }

  defaultUserSettings.forEach(({ key, value }) => {
    if (settingsStorage[key as keyof SettingsAppStorage] === undefined) {
      commands.setSettingsStorageValue({ [key]: value });
      setSettingsItems({ [key]: value });
    }
  });
};

const handleSetSettingsStorage = async (
  commands: SettingsCommands,
  settingsStorage: SettingsAppStorage & UserSettings
) => {
  const userSettings: UserSettings = {};
  const appSettings: SettingsAppStorage = {};

  Object.keys(settingsStorage).forEach((key) => {
    const value = settingsStorage[key as keyof typeof settingsStorage];
    if (isUserSettingsKey(key)) {
      Object.assign(userSettings, { [key]: value });
    } else if (isAppSettingsKey(key)) {
      Object.assign(appSettings, { [key]: value });
    }
  });

  if (Object.keys(userSettings).length) {
    await mutateUserSettings(userSettings);
    removeSettingsItems(Object.keys(userSettings));
  }

  commands.setSettingsStorageValue({ ...appSettings, settingsWereSet: true });

  applyMissingDefaults(commands, settingsStorage);
};

export const settingsMessageHandler = {
  handleSetSettingsStorage,
};
